import { render } from "./EditRequestDetails.vue?vue&type=template&id=3542ee24&scoped=true"
import script from "./EditRequestDetails.vue?vue&type=script&lang=js"
export * from "./EditRequestDetails.vue?vue&type=script&lang=js"

import "./EditRequestDetails.vue?vue&type=style&index=0&id=3542ee24&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3542ee24"]])

export default __exports__